module.exports = "https://www.gc-qa.gnp.com.mx/9350639b38393c00f6f0a173b992414d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/hospital.svg
// module id = 685
// module chunks = 0 1